export const dosageOptions:[string, string][] = [
    ["Milligram", "Milligram"],
    ["Gram", "Gram"],
    ["Microgram", "Microgram"],
    ["Millilitre", "Millilitre"],
];

export const freequencyOptions:[string, string][] = [
    ["Daily", "Day"],
    ["Weekly", "Week"],
    ["Fortnightly", "Fortnight"],
    ["Every Four Weeks", "Four Weeks"],
    ["Monthly", "Month"],
    ["Quarterly", "Quarter"],
    ["Half Yearly", "Half Year"],
    ["Yearly", "Year"],
    ["As Required", "As Required"],
];
